export default __webpack_public_path__ + "static/media/curse_of_the_forgotten_forest.94c2345b.svg";